export const britechartsCustomEvents = ['customMouseOver', 'customMouseMove', 'customMouseOut'];



// WEBPACK FOOTER //
// ./src/charts/constants.js